import { message } from "antd";
import AppointmentService from "../../Services/AppointmentService";

export const FETCH_WALLET_REQUEST = "FETCH_WALLET_REQUEST";
export const FETCH_WALLET_SUCCESS = "FETCH_WALLET_SUCCESS";
export const FETCH_WALLET_FAILURE = "FETCH_WALLET_FAILURE";

export const SAVE_LOGGED_USER = "SAVE_LOGGED_USER";
export const CLEAR_LOGGED_USER =  "CLEAR_LOGGED_USER";

export const SET_SELECTED_APPOINTMENT = "SET_SELECTED_APPOINTMENT";
export const CLEAR_SELECTED_APPOINTMENT = "CLEAR_SELECTED_APPOINTMENT";

export const fetchUserWalletDetails = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_WALLET_REQUEST });
  try {
    let result = await AppointmentService.GetWalletMoney(payload);
    dispatch({ type: FETCH_WALLET_SUCCESS, payload: result?.data[0] });
  } catch (error) {
    dispatch({ type: FETCH_WALLET_FAILURE });
    // message.error("An error Occured....");
  }
};

export const setSelectedAppt = (appt) => ({type:SET_SELECTED_APPOINTMENT,payload:appt});
export const clearSelectedAppt = (appt) => ({type:CLEAR_SELECTED_APPOINTMENT,payload:appt});

export const saveLoggedUser = (user) => ({type:SAVE_LOGGED_USER,payload:user});
export const clearLoggedUser = (user) => ({type:CLEAR_LOGGED_USER,payload:user});
